import { CollectionsApiClient } from '@fourthwall/services/dist/CollectionsApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useUpdateCollectionSlugMutation = createMutationHook(
  CollectionsApiClient.updateCollectionSlug,
  {
    mutationKey: ['updateCollectionSlug'],
  },
)
